function timeRemaining(activation, value) {
  var _a, _b;
  const end = ((_b = (_a = activation.instance) == null ? void 0 : _a.when) == null ? void 0 : _b.end) ?? 0;
  if (end === 0)
    return 0;
  return end - value;
}
const createActivationContext = (activation, context) => {
  var _a, _b, _c, _d, _e;
  const { apiBaseUrl, currentTimeMsec, isPreview, settings, distribution, tags } = context;
  return {
    api: {
      base: apiBaseUrl
    },
    googleMapsApiKey: (_a = settings == null ? void 0 : settings.credentials) == null ? void 0 : _a.googleMapsApiKey,
    activation: {
      id: activation.id,
      name: activation.name
    },
    preview: {
      text: (_b = activation == null ? void 0 : activation.preview) == null ? void 0 : _b.text,
      icon: (_c = activation == null ? void 0 : activation.preview) == null ? void 0 : _c.icon
    },
    distribution: {
      id: distribution.id,
      tags
    },
    campaign: (_d = activation == null ? void 0 : activation.instance) == null ? void 0 : _d.campaign,
    duration: (_e = activation == null ? void 0 : activation.instance) == null ? void 0 : _e.duration,
    timeRemaining: timeRemaining(activation, currentTimeMsec),
    isPreview
  };
};
export {
  createActivationContext
};
